import React, { PropTypes, Component } from 'react'

// Styles
import classes from './UserSearchbox.scss'

// Components
import Select from 'react-select'
import 'react-select/dist/react-select.css'

// Helpers
import { get, pickBy, identity, isEqual } from 'lodash'

class UserSearchbox extends Component {
  static propTypes = {
    onQuery: PropTypes.func.isRequired,
    offset: PropTypes.number.isRequired,
    companyOptions: PropTypes.array.isRequired,
    tagOptions: PropTypes.array.isRequired,
    aggregateResult: PropTypes.array.isRequired
  };

  static defaultProps = { offset: 0 };

  constructor (props) {
    super(props)
    this.state = {
      page: get(props, 'query.page'),
      keyword: get(props, 'query.keyword'),
      companyCode: get(props, 'query.companyCode'),
      category: get(props, 'query.category')
    }
  }

  componentDidMount () {
    window.objectFitImages()
  }

  componentWillReceiveProps (nextProps, nextState) {
    if (!isEqual(this.props.query, nextProps.query)) {
      this.setState({
        keyword: get(nextProps, 'query.keyword'),
        companyCode: get(nextProps, 'query.companyCode'),
        category: get(nextProps, 'query.category')
      })
    }
  }

  _cleanQuery = (state) =>
    pickBy({
      barcode: state.keyword,
      productCode: state.keyword,
      productName: state.keyword,
      description: state.keyword,
      genericName: state.keyword,
      companyCode: state.companyCode,
      category: state.category
    }, identity);

  componentWillUpdate (nextProps, nextState) {
    if (!isEqual(this.props.offset, nextProps.offset)) {
      console.log('componentWillUpdate', pickBy({
        offset: nextProps.offset,
        page: get(nextProps, 'query.page') || 1,
        keyword: nextState.keyword,
        barcode: nextState.keyword,
        productCode: nextState.keyword,
        productName: nextState.keyword,
        description: nextState.keyword,
        genericName: nextState.keyword,
        companyCode: nextState.companyCode,
        category: nextState.category
      }, identity))
      nextProps.onQuery(pickBy({
        offset: nextProps.offset,
        page: get(nextProps, 'query.page') || 1,
        keyword: nextState.keyword,
        barcode: nextState.keyword,
        productCode: nextState.keyword,
        productName: nextState.keyword,
        description: nextState.keyword,
        genericName: nextState.keyword,
        companyCode: nextState.companyCode,
        category: nextState.category
      }, identity))
    }
  }

  _onSearch = () => {
    const newSearch = (this.state.keyword !== this.state.prevKeyword) ||
      (this.state.companyCode !== this.state.prevCompanyCode) ||
      (this.state.category !== this.state.prevCategory)
    this.props.onQuery(pickBy({
      offset: newSearch ? 0 : this.props.offset,
      page: get(this.props, 'query.page') || 1,
      keyword: this.state.keyword,
      barcode: this.state.keyword,
      productCode: this.state.keyword,
      productName: this.state.keyword,
      description: this.state.keyword,
      genericName: this.state.keyword,
      companyCode: this.state.companyCode,
      category: this.state.category
    }, identity))
  }

  _isDisabled = () =>
    !this.state.keyword && (this.state.companyCode || this.state.category)

  render () {
    const { companyOptions, tagOptions, aggregateResult } = this.props
    const companyList = (aggregateResult || []).map(({ companyCode }) => companyCode)
    const filteredCompanyOptions = companyOptions.filter(option => !companyList.length || companyList.indexOf(option.value) > -1)
    const tagList = (aggregateResult || []).map(({ tag }) => tag)
    const filteredTagOptions = tagOptions.filter(option => !tagList.length || tagList.indexOf(option.value) > -1)

    return (
      <section id='user-searchbox' className={classes.container}>
        <div className={classes.mobileUserSearchbox}>
          <label>ค้นหาจากชื่อสินค้า/Barcode/รหัสสินค้า/ข้อบ่งใช้/Generic name</label>
          <div className={classes.keywordRow}>
            <input type='text'
              disabled={this._isDisabled()}
              className={`${classes.keywordSearch} ${this._isDisabled() && classes.disabled}`}
              value={this.state.keyword}
              onChange={(e) => this.setState({
                prevKeyword: this.state.keyword,
                keyword: e.target.value
              })}
              onKeyDown={({ keyCode }) => {
                if (keyCode === 13) this._onSearch()
              }} />
            <div className={`${classes.keywordClear} ${this.state.keyword && classes.visible}`}
              onClick={() => this.setState({ prevKeyword: this.state.keyword, keyword: '' }, this._onSearch)}>
              <span>×</span>
            </div>
          </div>
          <label>ค้นหาจากบริษัทจำหน่าย</label>
          <div className={classes.selector}>
            <Select name='company' value={this.state.companyCode}
              style={{ fontSize: 25 }}
              placeholder='บริษัทจำหน่าย'
              options={(!this.state.category && !this.state.keyword) ? companyOptions : filteredCompanyOptions}
              onChange={(data) => this.setState({
                prevCompanyCode: this.state.companyCode,
                companyCode: get(data, 'value')
              }, this._onSearch)} />
          </div>
          <label>ค้นหาจากหมวดหมู่สินค้า</label>
          <div className={classes.selector}>
            <Select name='tag' value={this.state.category}
              style={{ fontSize: 25 }}
              placeholder='หมวดหมู่สินค้า'
              options={(!this.state.companyCode && !this.state.keyword) ? tagOptions : filteredTagOptions}
              onChange={(data) => this.setState({
                prevCategory: this.state.category,
                category: get(data, 'value')
              }, this._onSearch)} />
          </div>
        </div>
        <div className='text-center'>
          <div className={classes.button} onClick={this._onSearch}>ค้นหา</div>
        </div>
      </section>
    )
  }
}

export default UserSearchbox



// WEBPACK FOOTER //
// ./src/components/UserSearchbox.js